const RATING_LABELS = ['1.0, 1.5, 2.0', '2.5', '3.0', '3.5', '4.0', '4.5', '5.0'];

const PERCENTAGES: Record<number, Array<[number, number]>> = {
  1: [[0, 0], [1, 5], [2, 6], [4, 7], [5, 8], [6, 10], [7, 11]],
  2: [[0, 0], [1, 6], [3, 7], [5, 8], [6, 10], [8, 12], [9, 14]],
  3: [[0, 0], [2, 9], [3, 10], [6, 12], [9, 14], [10, 16], [12, 19]],
  4: [[0, 0], [2, 10], [4, 11], [7, 13], [10, 16], [12, 19], [14, 22]],
  5: [[0, 0], [5, 23], [9, 27], [17, 31], [23, 37], [28, 44], [33, 51]],
  6: [[0, 0], [8, 42], [17, 48], [31, 56], [42, 67], [50, 79], [58, 91]],
  7: [[0, 0], [20, 100], [40, 115], [75, 135], [100, 160], [120, 190], [140, 220]],
  8: [[0, 0], [20, 100], [40, 115], [75, 135], [100, 160], [120, 190], [140, 220]],
};

export interface RatingGrantRow {
  rating: string;
  minPercent: number;
  maxPercent: number;
  minGrant: number;
  maxGrant: number;
}

export function ratingGrantRows(levelInput: number, averageInput: number): RatingGrantRow[] {
  const level = Math.min(8, Math.max(1, Math.trunc(levelInput || 1)));
  const average = level === 7 ? 95_542 : level === 8 ? 149_625 : Number(averageInput || 0);
  return (PERCENTAGES[level] || []).map(([minPercent, maxPercent], index) => ({
    rating: RATING_LABELS[index],
    minPercent,
    maxPercent,
    minGrant: Math.floor((average * minPercent) / 100 / 100) * 100,
    maxGrant: Math.floor((average * maxPercent) / 100 / 100) * 100,
  }));
}
